/**
 * Zdjęcia towarzyszące artykułom w bazie wiedzy.
 * Wykorzystujemy kadry z sesji i wystąpień, które nie były dotąd użyte na stronie.
 */
import type { CSSProperties } from "react";
import bigfive from "@/assets/sylwia-bigfive.jpg.asset.json";
import karteczki from "@/assets/sylwia-warsztat-karteczki.jpg.asset.json";
import conferenceIt from "@/assets/sylwia-conference-it.jpg.asset.json";
import rozmowa from "@/assets/sylwia-rozmowa-1na1.jpg.asset.json";
import speakingWhite from "@/assets/sylwia-speaking-white.jpg.asset.json";
import sluchanie from "@/assets/sylwia-warsztat-sluchanie.jpg.asset.json";
import scenaKontrola from "@/assets/sylwia-scena-kontrola.jpg.asset.json";
import publicznoscSala from "@/assets/sylwia-scena-ekran.jpg.asset.json";
import pracaZespol from "@/assets/sylwia-praca-zespol.jpg.asset.json";
import scenaSamotnosc from "@/assets/sylwia-sofa-granice.jpg.asset.json";

export type ArticleCover = {
  src: string;
  alt: string;
  objectPosition?: string;
  /** Powiększenie kadru (1 = bez powiększenia), przydaje się przy szerokich zdjęciach z prelekcji. */
  zoom?: number;
  /** Punkt, wokół którego następuje powiększenie, np. "25% 95%". */
  zoomOrigin?: string;
};

export const articleCovers: Record<string, ArticleCover> = {
  "syndrom-oszusta": {
    src: bigfive.url,
    alt: "Sylwia Sitkowska podczas wykładu o osobowości i kompetencjach liderów",
    objectPosition: "50% 35%",
  },
  perfekcjonizm: {
    src: karteczki.url,
    alt: "Warsztat z liderami, praca nad przekonaniami zapisanymi na karteczkach",
    objectPosition: "50% 45%",
  },
  "stres-w-pracy-a-decyzje": {
    src: conferenceIt.url,
    alt: "Sylwia Sitkowska na konferencji, wystąpienie o decyzjach pod presją",
    objectPosition: "50% 40%",
  },
  "samotnosc-lidera": {
    src: rozmowa.url,
    alt: "Rozmowa jeden na jeden z liderem podczas sesji",
    objectPosition: "50% 40%",
  },
  "wypalenie-zawodowe-u-lidera": {
    src: speakingWhite.url,
    alt: "Sylwia Sitkowska o wypaleniu zawodowym u lidera podczas wystąpienia",
    objectPosition: "50% 35%",
  },
  "mastermind-dla-przedsiebiorcow": {
    src: sluchanie.url,
    alt: "Sylwia Sitkowska słuchająca uczestników podczas pracy w małej grupie",
    objectPosition: "50% 40%",
  },
  "delegowanie-zadan": {
    src: scenaKontrola.url,
    alt: "Sylwia Sitkowska na scenie wskazuje slajd o nadmiernej kontroli i odpowiedzialności lidera",
    objectPosition: "50% 30%",
  },
  "konflikt-ze-wspolnikiem": {
    src: pracaZespol.url,
    alt: "Sylwia Sitkowska podczas rozmowy przy wspólnej pracy",
    objectPosition: "50% 45%",
  },
  "psychologia-przywodztwa": {
    src: publicznoscSala.url,
    alt: "Sylwia Sitkowska przemawia na scenie gali Business Woman Awards",
    objectPosition: "35% 30%",
  },
  "stawianie-granic-w-pracy": {
    src: scenaSamotnosc.url,
    alt: "Sylwia Sitkowska w jasnym garniturze podczas rozmowy na scenie",
    objectPosition: "50% 22%",
  },
};

export function coverFor(slug: string): ArticleCover | undefined {
  return articleCovers[slug];
}

/**
 * Powiększenie kadru na elemencie opakowującym — dzięki temu zdjęcie w kartach
 * zachowuje własny efekt powiększenia przy najechaniu.
 */
export function coverZoomStyle(cover: ArticleCover): CSSProperties {
  if (!cover.zoom) return {};
  return {
    transform: `scale(${cover.zoom})`,
    transformOrigin: cover.zoomOrigin ?? "50% 50%",
  };
}
